import { render, staticRenderFns } from "./login-layout.vue?vue&type=template&id=2d3038b5&scoped=true&"
import script from "./login-layout.vue?vue&type=script&lang=js&"
export * from "./login-layout.vue?vue&type=script&lang=js&"
import style0 from "./login-layout.vue?vue&type=style&index=0&id=2d3038b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3038b5",
  null
  
)

export default component.exports